"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _Constants = require("../Constants");

var getOptions = function getOptions(_ref) {
  var _ref$hideConsent = _ref.hideConsent,
      hideConsent = _ref$hideConsent === void 0 ? false : _ref$hideConsent,
      _ref$hideContract = _ref.hideContract,
      hideContract = _ref$hideContract === void 0 ? false : _ref$hideContract,
      _ref$showHelpText = _ref.showHelpText,
      showHelpText = _ref$showHelpText === void 0 ? false : _ref$showHelpText,
      _ref$hideNonGdpr = _ref.hideNonGdpr,
      hideNonGdpr = _ref$hideNonGdpr === void 0 ? false : _ref$hideNonGdpr;
  var options = [(0, _extends2.default)({
    text: _I18n.default.text("options.lawfulBasis." + _Constants.LawfulBasis.LEGITIMATE_INTEREST_PQL),
    value: _Constants.LawfulBasis.LEGITIMATE_INTEREST_PQL
  }, showHelpText && {
    help: _I18n.default.text("options.lawfulBasis.help." + _Constants.LawfulBasis.LEGITIMATE_INTEREST_PQL)
  }), (0, _extends2.default)({
    text: _I18n.default.text("options.lawfulBasis." + _Constants.LawfulBasis.LEGITIMATE_INTEREST_CLIENT),
    value: _Constants.LawfulBasis.LEGITIMATE_INTEREST_CLIENT
  }, showHelpText && {
    help: _I18n.default.text("options.lawfulBasis.help." + _Constants.LawfulBasis.LEGITIMATE_INTEREST_CLIENT)
  })];

  if (!hideContract) {
    options.push((0, _extends2.default)({
      text: _I18n.default.text("options.lawfulBasis." + _Constants.LawfulBasis.PERFORMANCE_OF_CONTRACT),
      value: _Constants.LawfulBasis.PERFORMANCE_OF_CONTRACT
    }, showHelpText && {
      help: _I18n.default.text("options.lawfulBasis.help." + _Constants.LawfulBasis.PERFORMANCE_OF_CONTRACT)
    }));
  }

  if (!hideConsent) {
    options.push((0, _extends2.default)({
      text: _I18n.default.text("options.lawfulBasis." + _Constants.LawfulBasis.CONSENT_WITH_NOTICE),
      value: _Constants.LawfulBasis.CONSENT_WITH_NOTICE
    }, showHelpText && {
      help: _I18n.default.text("options.lawfulBasis.help." + _Constants.LawfulBasis.CONSENT_WITH_NOTICE)
    }));
  }

  if (!hideNonGdpr) {
    options.push((0, _extends2.default)({
      text: _I18n.default.text("options.lawfulBasis." + _Constants.LawfulBasis.NON_GDPR),
      value: _Constants.LawfulBasis.NON_GDPR
    }, showHelpText && {
      help: _I18n.default.text("options.lawfulBasis.help." + _Constants.LawfulBasis.NON_GDPR)
    }));
  }

  return options;
};

var _default = function _default(props) {
  return _react.default.createElement(_UIFormControl.default, (0, _extends2.default)({
    label: _I18n.default.text('labels.lawfulBasis')
  }, props.formControlProps), _react.default.createElement(_UISelect.default, (0, _extends2.default)({
    placeholder: _I18n.default.text('placeholders.lawfulBasis')
  }, props, {
    options: getOptions(props),
    dropdownClassName: "untruncate",
    "data-selenium-test": "gdpr-legal-basis-select"
  })));
};

exports.default = _default;
module.exports = exports.default;